import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22game-results.tsx%22,%22import%22:%22Lexend%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22300%22,%22400%22]}],%22variableName%22:%22lexend%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Lexend', 'Lexend Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
